import ReactDOM from "react-dom/client";
import "./assets/css/app.css";
import AppContent from "./AppContent";
import AppProviders from "./AppProviders";
import * as Sentry from "@sentry/react";

if (process.env.REACT_APP_ENV == "Production") {
  try {
    Sentry.init({
      dsn: "https://400e7b565f1e36e1d181fef2c8bddb67@o4506772476264448.ingest.us.sentry.io/4509688503664647",
      integrations: [Sentry.browserTracingIntegration()],
      // Performance Monitoring
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: [
        "https://crm.flightdaddy.ca",
        /^https:\/\/yourserver\.io\/api/,
      ],
    });
  } catch (error) {
    console.log("Sentry: ", error);
  }
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <AppProviders>
    <AppContent />
  </AppProviders>
);
